import { createRoot } from 'react-dom/client';
import { App } from './App';
import { consumeFormSubmittedForBfcacheReloadFlag } from '../../shared/utils';

function renderRoot() {
  const elementById =
    document.getElementById('tax-root') || document.getElementById('root');
  if (!elementById) {
    console.error("Element with ID 'tax-root' or 'root' not found.");
    return;
  }

  console.log(
    '%cMark 12:17 "Render unto Caesar the things that are Caesar\'s, and unto God the things that are God\'s."',
    'color: green'
  );

  const root = createRoot(elementById);
  root.render(<App />);
}

// A bfcache restore (e.g. pressing back after a successful submission) resumes this page's
// frozen JS state instead of re-running this script, which can leave the wizard stuck
// mid-submission or risk a duplicate referral if the user interacts with the stale form again.
// Only force a reload for that specific case - a bfcache restore of an in-progress,
// not-yet-submitted form is left alone so the user's answers are still there, same as before
// bfcache existed as a browser optimization.
function initBfcacheReload() {
  window.addEventListener('pageshow', (event) => {
    // Consume on every pageshow, not just bfcache restores. A normal (non-bfcache) return to
    // this page must still clear the flag, otherwise it survives in sessionStorage and would
    // wrongly trigger a reload on some later bfcache restore of an in-progress form.
    const wasSubmittedBeforeFreeze = consumeFormSubmittedForBfcacheReloadFlag();
    if (event.persisted && wasSubmittedBeforeFreeze) {
      window.location.reload();
    }
  });
}

export { renderRoot, initBfcacheReload };
